import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from 'antd'
import React, { useRef, useState } from 'react'
import { getUserList } from '../../api/api'
import UserTable from './components/userTable/userTable'
import moment from 'moment'
import './index.css'
import { useEffect } from 'react'

const { RangePicker } = DatePicker

const UserManage = () => {
  const [componentSize, setComponentSize] = useState('default')

  

  const [isFresh, setIsfresh] = useState(false) //刷新父组件
  const [payload, setPayload] = useState({
    page: '1',
    pagesize: '10',
  })
  const [total, setTotal] = useState(0)

  const [form] = Form.useForm()
  const unitref = useRef(null)
  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size)
  }

  useEffect(() => {
    getUserList({ params: payload }).then((res) => {
      const info = res.data.data
      if (info.total === 0) {
        message.error('未能找到指定条件内容！')
      }
      unitref.current.changeTable(info.rows)
      setTotal(info.total)
    })
  }, [payload, isFresh])

  //重置选项
  const resetSelectors = () => {
    form.resetFields()
  }

  const handleSubmit = (values) => {
    let start = values?.date[0]
    let end = values?.date[1]

    let payload = {
      page: '1',
      pagesize: '10',
      name_or_phone: values?.nameorphone,
      is_membership: values?.type,
    }
    if (start !== undefined) {
      payload['period_start'] = moment(start).format('YYYY-MM-DD')
    }
    if (end !== undefined) {
      payload['period_end'] = moment(end).format('YYYY-MM-DD')
    }
    setPayload(payload)
  }
  //分页改变时的回调
  const pageChange = (e) => {
    setPayload({
      ...payload,
      page: e,
    })
  }


  return (
    <div className="useManage">
      <Form
        initialValues={{
          size: componentSize,
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        className="userSelectors"
        form={form}
      >
        <Row>
          <Col span={7} offset={1}>
            <Form.Item label="用户信息" name="nameorphone" className="userInfo">
              <Input placeholder="请输入用户昵称/手机号码" />
            </Form.Item>
          </Col>
          <Col span={6} offset={1}>
            <Form.Item label="用户性质" name="type" className="userType">
              <Select
                mode="multiple"
                placeholder="请选择"
                style={{ textAlign: 'left' }}
              >
                <Select.Option value="1">会员</Select.Option>
                <Select.Option value="0">非会员</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8} offset={1}>
            <Form.Item
              label="注册时间"
              name="date"
              className="userTime"
              initialValue=""
            >
              <RangePicker
                format="YYYY-MM-DD"
                initialValues={moment('', 'yyyy-mm-dd')}
              />
            </Form.Item>
          </Col>
          <Col span={20}></Col>
          <Col>
            {' '}
            <div className="selector_button">
              <Button onClick={resetSelectors}>重置</Button>
              <Form.Item
                wrapperCol={{
                  span: 12,
                  offset: 6,
                }}
              >
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Form>

      <UserTable ref={unitref} setIsfresh={setIsfresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: 'right', marginTop: '20px' }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  )
}
export default UserManage
